export default (axios, checkHeaders) => ({
  postMail (data = {}) {
    return axios.post('/mail', data.body, { params: data.filters || {} })
  },
})
